import React from 'react';

const EmotionContext = React.createContext(null);

export default EmotionContext;